import { createFileRoute } from "@tanstack/react-router";
import SuperLayoutTitle from "@/components/layout/super-layout/super-layout-title";
import PlansConfigurations from "@/components/plans/plans-configuration";
import { modulesTypes } from "@/convex/system/permissions";

export const Route = createFileRoute("/_super/super/plans")({
  component: PlansPage,
});

function PlansPage() {
  return (
    <>
      <SuperLayoutTitle
        title="Gestión de Planes"
        subtitle="Configura los planes de suscripción del sistema"
      />
      <PlansConfigurations module={modulesTypes.type} />
    </>
  );
}
